import SpinnerNormal from "components/view/spinner-normal";
import UboxRewardShow from "components/view/ubox_reward_show";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import getinfo from "lib/worker/api/getinfo";
import topup_venlentine, {
  TopupVemlentineBetResponse,
} from "lib/worker/api/topup_venlentine";
import { GetServerSideProps } from "next";
import Link from "next/link";
import { useState } from "react";
import Img from "react-cloudimage-responsive";
import LayoutMaster from "../../components/layout/layout_master";

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

interface Props {
  infomation: CheckWithPrefixResponse;
}

export default function Valentine(props: Props) {
  const [topup, settopup] = useState<TopupVemlentineBetResponse>();
  const [animationa, setanimationa] = useState("checkin");
  const [animationimagea, setanimationimagea] = useState(
    "valentine-gift-box.png.png"
  );
  const [idx, setid] = useState(0);
  const [idxforloading, setidforloading] = useState(0);
  const [isloading, setisloading] = useState<boolean>(false);

  const bet = (id: number) => {
    if (idx != 0) {
      return;
    }

    setisloading(true);
    setidforloading(id);
    topup_venlentine()
      .then((json) => {
        setid(id);
        settopup({
          AmountA: json.AmountA,
          AmountB: json.AmountB,
          IsCredit: json.IsCredit,
        });
        shake(id);
        getinfo();
        return json;
      })
      .catch((error) => {
        alert(error.response.data.message);
      })
      .finally(() => {
        setisloading(false);
      });
  };

  const shake = (id: number) => {
    switch (id) {
      case 1:
        setanimationa("shake");
        setTimeout(() => {
          setanimationimagea("valentine-gift-box-open.png.png");
        }, 500);
        break;
    }
  };

  const displayCredit = () => {
    if (topup?.IsCredit) {
      return topup?.AmountA ? (
        <div className="row">
          <label
            className="col-6 center-row-content  text-center"
            style={{
              position: "relative",
              fontSize: "1rem",
              color: "#ffbe00",
            }}
          >
            ได้รับ {topup?.AmountA.format(0, 0) ?? "..."} ฿
          </label>
          <label
            className="col-6 center-row-content text-center"
            style={{
              position: "relative",
              fontSize: "1rem",
              color: "#ffbe00",
            }}
          >
            ได้รับ {topup?.AmountB.format(0, 0) ?? "..."} ฿
          </label>
        </div>
      ) : (
        "..."
      );
    } else {
      return "ได้รับ 1,000 uDiamond";
    }
  };

  const showAward = (id: number) => {
    if (idx == 0 || isloading) {
      if (idxforloading == id) {
        if (isloading) {
          return (
            <div
              className="row center-row-content col"
              style={{
                position: "relative",
                marginTop: -51,
                marginBottom: 19,
              }}
            >
              <SpinnerNormal></SpinnerNormal>
            </div>
          );
        }
      }
      return "";
    }

    if (id == idx) {
      return (
        <div
          className="tranparent-bg-black col text-center"
          style={{ marginTop: -34, paddingTop: 5, paddingBottom: 5 }}
        >
          {displayCredit()}
        </div>
      );
    } else {
      return (
        <label
          className="row center-row-content tranparent-bg-black"
          style={{
            marginTop: -34,
            position: "relative",
            fontWeight: 0.7,
          }}
        >
          ได้รับ 1,000 uDiamond ฿
        </label>
      );
    }
  };

  const showGlowAward = (id: number) => {
    if (idx == 0) {
      return "";
    }

    if (id == idx) {
      return "";
    } else {
      return "";
    }
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "แจกกล่องของขวัญ วาเลนไทน์ เครดิตฟรี",
        description:
          "ทางเรา ใจดี แจกของขวัฐ วันแห่งความรัก ตั้งแต่ 20 จนถึง!! 1,000 บาทเพียงท่านฝากเงินครั่งแรกของวัน โดยกิจกรรมจะรีทุก เที่ยงคืน หรือ 00.00 น.",
      }}
      information={props.infomation}
    >
      <div className="container">
        <h1 className="text-title text-center" style={{ paddingTop: 10 }}>
          แจกกล่องของขวัญวาเลนไทน์ สำหรับสมาชิกที่ฝากเงินครั้งแรกของวัน
        </h1>
        <div className="margin-top-20">
          <div className="row center-row-content">
            <div
              className={`col-8 col-sm-8 col-md-6 col-lg-4`}
              onClick={() => {
                bet(1);
              }}
            >
              <div className={` ${animationa}`}>
                <Img
                  ratio={0.8}
                  className={showGlowAward(1)}
                  src={animationimagea}
                  alt="กล่องวาเลนไทน์ ฟรีเครดิต"
                ></Img>
              </div>

              {showAward(1)}
            </div>
          </div>
        </div>
        <div className="margin-top-40">
          <h4 className="text-title">ระยะเวลากิจกรรม</h4>
          <p>
            ระยะเวลาสิ้นสุดกิจกรรม:{" "}
            <span>14 กุมภาพันธ์ 2565 - 16 กุมภาพันธ์ 2565</span>{" "}
          </p>
          <h4 className="text-title">วิธีการร่วมกิจกรรม</h4>
          <li>
            <span>ฝากเงินครั้งแรก</span> ของวันเพื่อรับสิทธ์เข้าร่วมกิจกรรม
          </li>
          <li>สามารถเข้าร่วมกิจกรรมได้ทุกวัน จนถึง วันสิ้นสุดกิจกรรม</li>
          <li>
            โดยกิจกรรมจะรีเซตทุกวัน เวลา 00.00 น. จนถึง วันที่{" "}
            <span>16 กุมภาพันธ์ 2565 เวลา 23.59 น.</span>
          </li>
          <li>
            เปิด <span>กล่องของขวัญวาเลนไทน์</span>
            เพื่อลุ้นของรางวัล เครดิตฟรี
          </li>
          <li>
            เมื่อท่านเปิด <span>กล่องของขวัญวาเลนไทน์</span>{" "}
            ข้างในกล่องจะลุ้นรางวัล ถึง 2 รางวัลด้วยกัน แล้ว ระบบจะเพิ่ม{" "}
            <span>uDiamond</span> ให้ท่านอัตโนมัติ
          </li>
          <li>
            ท่านสามารถนำ <span>uDiamond</span> ที่ได้รับไปแลกเป็นเงินได้ โดย{" "}
            <span>300 uDiamond</span> เท่ากับ <span>1 บาท</span>{" "}
            <Link href="/exchange">
              <a>
                <span style={{ textDecoration: "underline" }}>
                  คลิกเพื่อแลกเงิน
                </span>
              </a>
            </Link>
          </li>

          <li className="font-red">
            หากพบว่าลูกค้ามีเจตนาที่ไม่สุจริตเช่นการฝากเงิน
            แล้วถอนออกโดยไม่มีการเดิมพัน
            ทางเว็บขอยกเลิกสิทธิการรับรางวัลแก่สมาชิกที่มีเจตนาไม่สุจริต
          </li>
          <br></br>
          <h4>
            <span>ของรางวัลที่ได้จากการเปิดกล่องวาเลนไทน์</span>
          </h4>
          <ul>
            <li>
              ได้รับของรางวัลจากกล่องวาเลนไทน์ ตั้งแต่{" "}
              <span>6,000 uDiamond</span> จนถึง!! <span>300,000 uDiamond </span>
            </li>
            <li>
              โดย <span>300 uDiamond</span> สามารถแลกได้ <span>1 บาท</span>{" "}
              <Link href="/exchange">
                <a>
                  <span style={{ textDecoration: "underline" }}>
                    คลิกเพื่อแลกเงิน
                  </span>
                </a>
              </Link>
            </li>
          </ul>
          <div className="margin-top-10">
            {ValentineRewards.map((value, index) => {
              return (
                <UboxRewardShow
                  key={index}
                  List={`ของรางวัลที่ - ${index + 1} `}
                  Name={`${value.name} : ${value.uname} `}
                  Pc={value.pc}
                ></UboxRewardShow>
              );
            })}
          </div>
        </div>
      </div>
    </LayoutMaster>
  );
}

const ValentineRewards = [
  {
    name: "20 บาท",
    uname: "6,000 uDiamond",
    pc: "26.32 %",
  },
  {
    name: "30 บาท",
    uname: "9,000 uDiamond",
    pc: "26.32 %",
  },
  {
    name: "50 บาท",
    uname: "15,000 uDiamond",
    pc: "26.32 %",
  },
  {
    name: "100 บาท",
    uname: "30,000 uDiamond",
    pc: "19.74 %",
  },
  {
    name: "200 บาท",
    uname: "60,000 uDiamond",
    pc: "1.05 %",
  },
  {
    name: "500 บาท",
    uname: "150,000 uDiamond",
    pc: "0.13 %",
  },
  {
    name: "1,000 บาท",
    uname: "300,000 uDiamond",
    pc: "0.09 %",
  },
];
